import React from "react";
import ConfigureButton from "../../motorcyclecustomizer/ConfigureButton";
import classic  from "../../asset/classic.jpg";
import righticon from '../../asset/Updatedbuttons.png';
import { URL } from "../../config";

const logAnalyticsEvent = (eventName, params = {}) => {
  const payload = { name: eventName, parameters: JSON.stringify(params) };
  console.log("📊 Logging Analytics:", payload);

  if (window.Android?.logAnalyticsData) {
    window.Android.logAnalyticsData(payload.name, payload.parameters);
  } else if (window.webkit?.messageHandlers?.logAnalyticsData?.postMessage) {
    window.webkit.messageHandlers.logAnalyticsData.postMessage(payload);
  } else {
    console.warn("[Bridge] logAnalyticsData not available");
  }
};

const Customizer = () => {
  const handleConfigureNow = () => {
  const configureId = 6.01;
  const configureUrl = URL.MAKE_IT_YOURS;

  logAnalyticsEvent("configure_now", {
    clickText: "configure now",
    sectionHeading: "configurator",
    screenname: "home_screen",
  });

  // Call the bridge function to pass the ID and URL to the mobile app
  if (window.passURLtoMobile) {
    window.passURLtoMobile(configureId, configureUrl);
  } else {
    console.warn("Native bridge function not found");
  }

  // Call the logSFSDKEvent bridge function
  if (window.Android && typeof window.Android.logSFSDKEvent === "function") {
    window.Android.logSFSDKEvent("Configure Now - Mob", "");
  } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.logSFSDKEvent) {
    window.webkit.messageHandlers.logSFSDKEvent.postMessage({
      eventTitle: "Configure Now - Mob",
      eventValue: ""
    });
  } else {
    console.warn("logSFSDKEvent bridge function not found");
  }  
};


  return (
    <section className="relative top-4 sm:top-4 bg-black text-white overflow-hidden flex flex-col justify-center">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex flex-row gap-6">
        <div className="relative z-2 max-w-4xl mx-auto">
          <h2 className="font-['Guardian_Sans_XCondSemi'] mt-2.5 mb-3 text-[32px] leading-[32px] tracking-normal flex items-center text-white">
            Configurator
          </h2>
          <p
            className="max-w-xl mb-4 sm:mb-8"
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "21px",
              textAlign: "left",
              textUnderlinePosition: "from-font",
              textDecorationSkipInk: "none",

              color: "#A6A6A6",
            }}
          >
            From parts to paint, customize your motorcycle your way.
          </p>
        </div>
        <div className='flex items-start'>
          <button
            className='relative w-12 h-12 flex items-center justify-center overflow-hidden -mt-1.4'
            onClick={handleConfigureNow}
          >
            <div className='absolute inset-0 -mt-2' />
            <img src={righticon} alt='Custom Icon' className='w-10 h-10 relative z-10' />
          </button>
        </div>
      </div>

      {/* Full-width image with no left or right gaps */}
      <div className="relative w-screen">
        <img
          src={classic}
          alt="Background"
          className="w-screen h-auto object-cover"
        />
      </div>

      <div className="container mb-4 mt-5 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center">
          <ConfigureButton onClick={handleConfigureNow} />
        </div>
      </div>

      {/* Full-width background effect for modern look */}
      <div className="absolute inset-0 w-full h-full bg-gradient-to-t from-transparent to-black opacity-30 pointer-events-none"></div>
    </section>
  );
};

export default Customizer;